<template>
  <label
    class="text-background-fg/87 flex items-center space-x-2 text-sm"
  >
    <span> Showing</span>
    <input
      type="number"
      :value="modelValue"
      :class="[
        'text-background-fg/70 border-1 border-background-fg/8 bg-background block w-16 rounded-full px-3 py-1 text-center text-xs font-medium shadow-sm',
        'disabled:opacity-70',
        'focus:ring-primary focus:border-primary',
      ]"
      @input="onInput"
    />
    <span> products</span>
  </label>
</template>

<script setup lang="ts">
const props = defineProps<{ modelValue: number }>()
const emit = defineEmits<{
  (
    event: "update:modelValue",
    value: typeof props.modelValue
  ): void
}>()

const onInput = (event: Event) => {
  const value = (event.target as HTMLInputElement)?.value
  emit("update:modelValue", Number(value))
}
</script>
